import React from 'react';
import {useSvgToElements} from './useSvgToElements';

export const Indeterminate = (
  props: any
): React.ReactElement<React.ComponentProps<'svg'>> => {
  const svgProps = useSvgToElements({
    ...props,
    width: 8,
    height: 2,
    name: 'indeterminate',
  });

  return (
    <svg viewBox="0 0 8 2" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <rect
        width="8"
        height="2"
        rx="1"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default Indeterminate;
